import React from 'react'

import { KeyPairValueKeys, useGetKeyPairValue } from 'api/core/useAPIKeyValue'

import type { TResponseSuccessGetContentSearchFilterResult } from 'types/content-search'

const useSearchFilters = () => {
  const { data: responseData, isSuccess } =
    useGetKeyPairValue<TResponseSuccessGetContentSearchFilterResult>(
      KeyPairValueKeys.ContentSearchFilters
    )

  const filtersData = React.useMemo<
    TResponseSuccessGetContentSearchFilterResult | Record<string, never>
  >(
    () => (isSuccess ? responseData?.data : {}),
    [isSuccess, responseData?.data]
  )

  const hasSearchFiltersData = React.useMemo(
    () => Boolean(filtersData),
    [filtersData]
  )

  return {
    searchFiltersData: filtersData,
    hasSearchFiltersData,
  }
}

export default useSearchFilters
